import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonHttpModule } from "../../providers/commonHttpModule";
import { MaVessel } from "src/app/modules/Disbursment_modules/dis-repository/pages/create-client/vessel.model";



@Injectable({
  providedIn: "root",
})
export class VesseService {
  constructor(private http: CommonHttpModule) {

  }

  // method to post the data to Db
  VesselDataToDB(data: any): Observable<any> {
    const imo = data.imo_number;
    data.imo_number = imo !== null && imo !== undefined ? imo.toString() : null;
    data.status = data.status === true ? 'Y' : 'N';
    return this.http.post("vessels", data).pipe(
      map((response) => {
        return response;
      })
    )
  }

  // method to get the all vessels
  VesselDataFromDb(data: any): Observable<{ data: MaVessel[]; total_count: number }> {
    const imo = data.imo_number;
    data.imo_number = imo !== null && imo !== undefined ? imo.toString() : null;
 
    return this.http.post<{ total_count: number, data: MaVessel[] }>("vessellist", data)
      .pipe(
        map(response => ({
          total_count: response.total_count,
          data: response.data
        }))
      );
  }

}